import { styled, Card, Paper, alpha } from '@mui/material';
import { CHART_CONFIG, ANIMATION_CONFIG } from '../constants/dashboardConstants';

export const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  transition: `all ${ANIMATION_CONFIG.HOVER_DURATION} ease-in-out`,
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[8],
  },
}));

export const MetricCard = styled(Card)(({ theme, color = 'primary' }) => ({
  height: '100%',
  background: `linear-gradient(135deg, ${alpha(theme.palette[color].main, 0.1)} 0%, ${alpha(theme.palette[color].main, 0.05)} 100%)`,
  border: `1px solid ${alpha(theme.palette[color].main, 0.2)}`,
  transition: `all ${ANIMATION_CONFIG.HOVER_DURATION} ease-in-out`,
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[8],
  },
}));

export const ChartCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  height: `${CHART_CONFIG.CHART_HEIGHT}px`,
  display: 'flex',
  flexDirection: 'column',
}));

export const NoteCard = styled(Card)(({ theme }) => ({
  height: '100%',
  position: 'relative',
  transition: `all ${ANIMATION_CONFIG.HOVER_DURATION} ease-in-out`,
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[6],
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: `linear-gradient(90deg, ${theme.palette.success.main} 0%, ${theme.palette.info.main} 100%)`,
  },
}));

export const MUIChart = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  height: `${CHART_CONFIG.CHART_HEIGHT}px`,
  display: 'flex',
  flexDirection: 'column',
  background: `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  overflow: 'hidden'
})); 